import PubSub from 'pubsub-js';
import { WEB_MAP_API_TOPIC } from '../constants/WebMap';

export default class ApiStateManager {
    static instance = null;
    _requestCount = 0;

    /**
     * @returns {ApiStateManager}
     */
    static getInstance() {
        if (ApiStateManager.instance == null)
            ApiStateManager.instance = new ApiStateManager();

        return this.instance;
    }

    getRequestCount() {
        return this._requestCount;
    }

    setRequestCount(val) {
        const count = this._requestCount + Number(val);
        this._requestCount = count < 0 ? 0 : count;
        this.#publishReqCount();
    }

    #publishReqCount() {
        PubSub.publish(WEB_MAP_API_TOPIC, this._requestCount);
    }
}